const ExcludedActivitiesList = ({
  excludedActivities,
}: {
  excludedActivities: string[];
}) => {
  const middleIndex = Math.floor(excludedActivities.length / 2);
  const firstHalf = excludedActivities.slice(0, middleIndex);
  const secondHalf = excludedActivities.slice(middleIndex);

  return (
    <div>
      <div className="row">
        <div className="col-sm">
          <ul className="mb-0">
            {firstHalf.map((activityName) => (
              <li key={activityName}>{activityName}</li>
            ))}
          </ul>
        </div>
        <div className="col-sm">
          <ul className="mb-0">
            {secondHalf.map((activityName) => (
              <li key={activityName}>{activityName}</li>
            ))}
          </ul>
        </div>
      </div>
      <p className="mt-5 label form-error__label">
        For any event not found on the GatherGuard application under “Select
        your event” or “Other event types”, please call{" "}
        <a href="tel:+1-844-747-6240">844-747-6240</a> to confirm event
        eligibility.
      </p>
    </div>
  );
};

export default ExcludedActivitiesList;
